<template>
    <div class="banner d-flex justify-content-center align-items-center mb-3">
        <div v-for="(item, index) in imageData"
             class="mb-1"
             :key="index">
            <a :href="item.link||''">
                <img :src="item.imageUrl"
                     :alt="item.title"
                     v-if="item.imageUrl" />
            </a>
        </div>
    </div>
</template>

<script>
import { request } from '@/service';

export default {
    name: 'Banner',
    props: {
        srcId: String
    },
    data() {
        return {
            imageData: []
        };
    },
    watch: {
        srcId(value) {
            this.getImage();
        }
    },
    methods: {
        getImage() {
            request({
                method: 'POST',
                api: '/api/getSaleActivity',
                base: true,
                data: {
                    srcId: this.srcId,
                }
            })
                .then(res => {
                    this.imageData = res.data.saleActivityList;
                }).catch((error) => {
                    this.$notify({
                        group: 'alert',
                        title: error.data[0].error,
                        type: 'error',
                    });
                });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.banner {
    max-width: 540px;
    margin: auto;
    // height: 100px;
    img {
        width: 100%;
    }
}
</style>
